import { showModal } from 'modal.react.js';
import { Sparkle } from 'phosphor-react';

import Button from 'components/shared/Button';
import area from 'components/shared/GlobalModalArea/area';
import Icon from 'components/shared/Icon';
import Loader from 'components/shared/Loader';
import Text from 'components/shared/Typography/Text';

import s from './MagicImportButton.module.css';
import { MagicImportModal } from './MagicImportModal';
import { useMagicImport } from './useMagicImport';

export const MagicImportButton = () => {
  const { status, magicImport } = useMagicImport();
  const isLoading = status !== 'idle';

  const openMagicImportModal = () => {
    showModal(area, <MagicImportModal onSubmit={magicImport} />);
  };

  return (
    <Button type="empty" className={s.button} onClick={openMagicImportModal} disabled={isLoading}>
      {isLoading ? (
        <div className={s.loader}>
          <Loader width={18} height={18} />
        </div>
      ) : (
        <Icon component={Sparkle} className={s.icon} />
      )}
      <Text type="brandon" size="regular">
        Magic Import
      </Text>
    </Button>
  );
};
